var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { SettingsController } from '../../utils/SettingsController';
import { getVariant } from '../../utils/variants';
import { trackExperiment } from './utils';
let Experiment = class Experiment extends LitElement {
    constructor() {
        super(...arguments);
        this.autoTrack = false;
        this.hasVariant = false;
        this._settingListener = new SettingsController(this, this.requestUpdate.bind(this));
    }
    async willUpdate(_changedProperties) {
        if (!this.variant) {
            this.variant = getVariant(this.experiment);
        }
        if (window.trustSettings) {
            if (!this.hasVariant && this.variant === this.group && this.autoTrack) {
                await trackExperiment(this.experiment, this.variant, window.trustSettings.brand);
                this.hasVariant = true;
            }
            else {
                this.hasVariant = true;
            }
        }
    }
    render() {
        if (!this.hasVariant ||
            (this.variant !== this.group &&
                !(this.variant === undefined && this.group === 'control')))
            return nothing;
        return html `<slot></slot>`;
    }
};
__decorate([
    property()
], Experiment.prototype, "classNames", void 0);
__decorate([
    property()
], Experiment.prototype, "experiment", void 0);
__decorate([
    property()
], Experiment.prototype, "group", void 0);
__decorate([
    property({ type: Boolean })
], Experiment.prototype, "autoTrack", void 0);
__decorate([
    state()
], Experiment.prototype, "variant", void 0);
__decorate([
    state()
], Experiment.prototype, "hasVariant", void 0);
Experiment = __decorate([
    customElement('trust-experiment')
], Experiment);
export { Experiment };
//# sourceMappingURL=experiment.js.map